// extracted by mini-css-extract-plugin
export default {"Loader":"ipirVtfi6HyIz43aDDAw","load8":"OSiycHON5vMuu7RKKu0R","LoaderLabel":"Z599HCRUeMxjRByxCahy"};